import { render, staticRenderFns } from "./OutrosEspecificos.vue?vue&type=template&id=57d3922e&scoped=true"
import script from "./OutrosEspecificos.vue?vue&type=script&lang=js"
export * from "./OutrosEspecificos.vue?vue&type=script&lang=js"
import style0 from "./OutrosEspecificos.vue?vue&type=style&index=0&id=57d3922e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3922e",
  null
  
)

export default component.exports